export default "__VITE_ASSET__5479b4a4__"